// extracted by mini-css-extract-plugin
module.exports = {"close":"swiper_close__eXfhY","swiper":"swiper_swiper__DQQF7"};